module.exports = __webpack_public_path__ + "img/logo4.fdc51a8d.png";